/**
 * Component used to indicate that the entity is a custom sliding door. Component is added when user selects the custom sliding door
 * option from the menu and is removed (by the CustomSlidingDoorSystem) when user unselects the sliding door after customizing it.
 */
class CustomSlidingDoorComponent {
    constructor() {
        this.typeId = CustomSlidingDoorComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
CustomSlidingDoorComponent.id = 2035;
export default CustomSlidingDoorComponent;
//# sourceMappingURL=CustomSlidingDoorComponent.js.map